export default function (file) {
  let reader = new FileReader()
  reader.addEventListener('load', () => {
    this.$emit('load', reader.result)
  })
  reader.readAsDataURL(file)
}
